/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { withClient } from 'fierry/react';

import BorderGeometry from 'solis/react/board/geometry/border';

import * as Hexagon from 'solis/type/point/hexagon';
import * as Point from 'solis/type/point';


export default withClient(class
{
  constructor ({ zoneData, hexGeometry })
  {
    this.hexGeometry = hexGeometry;

    this.initializePoints(zoneData);
    this.initializeBorders(zoneData);
  }


  initializePoints (zoneData)
  {
    this.zonePoints = this.hexGeometry.getPoints(zoneData);
  }


  initializeBorders (zoneData)
  {
    this.borders = [];

    for (let index = 0; index < Hexagon.getPointCount(); ++index)
    {
      const currentTriangle = this.__calculateTriangle__(index, this.zonePoints);
      const externalTriangle = this.__calculateTriangle__(index, this.hexGeometry.getExternalPoints());

      this.borders.push(new BorderGeometry(index, currentTriangle, externalTriangle, zoneData, this.hexGeometry));
    }
  }


  __calculateTriangle__ (index, points)
  {
    const center = { x: 0, y: 0 };

    return [ points[index], points[Hexagon.getPointIndex(index + 1)], center ];
  }


  getPoints ()
  {
    return this.zonePoints;
  }


  getOutlinePoints ()
  {
    return this.borders.flatMap(border => border.getOutlinePoints().slice(0, -1));
  }


  getBorders ()
  {
    return this.borders;
  }


});
